import InputLabel from "@mui/material/InputLabel";
import React from "react";

interface FormikInputLabelProps {
  name: string;
  required?: boolean;
  label: string;
  isError?: boolean;
  errorMessage?: string;
  labelClasses: { label: string; labelFlex: string; errorText: string };
  disabled?: boolean;
}

const FormikInputLabel: React.FC<FormikInputLabelProps> = ({
  name,
  required,
  label,
  isError,
  errorMessage,
  labelClasses,
  disabled
}) => {
  return (
    <InputLabel
      htmlFor={name}
      required={required}
      className={labelClasses.label + " " + labelClasses.labelFlex}
      error={Boolean(isError)}
      disabled={!!disabled}
    >
      {label}
      {isError && errorMessage && (
        <span className={labelClasses.errorText}>({errorMessage})</span>
      )}
    </InputLabel>
  );
};

export default FormikInputLabel;
